export enum ENUM_STORE_NAMES {
  CASINO_LOBBY = "casinoLobby",
}
